import { render } from "./MfaDialog.vue?vue&type=template&id=389b5760&scoped=true"
import script from "./MfaDialog.vue?vue&type=script&lang=js"
export * from "./MfaDialog.vue?vue&type=script&lang=js"

import "./MfaDialog.vue?vue&type=style&index=0&id=389b5760&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-389b5760"]])

export default __exports__